import {useState} from "react";
import style from './Navbar.module.css';

export default function Navbar(props: {user: string|undefined, onStartClick: () => void}) {

    const [live, setLive] = useState(false);

    return (
        <div
            className="h-12 px-6 flex items-center relative
            border-b border-black"
        >
            <span className={`text-2xl md:text-3xl ${style.logo}`}>Dumberg</span>
            <span className="absolute right-6 flex items-center">
                <div className="pr-2">
                    @<span className="font-bold">{props.user || ''}</span>
                </div>
                <button
                    className="px-2 py-1 flex items-center
                    border border-black rounded-md
                    hover:text-gray-500 hover:border-gray-500"
                    onClick={() => { setLive(true); props.onStartClick(); }}
                    disabled={live}
                >
                    <div>{live ? "On Live" : "Go Live"}</div>
                    <div className={`w-3 h-3 ml-1 rounded-full ${live ? "bg-red-500" : "bg-gray-400"}`}></div>
                </button>
            </span>
        </div>
    );

}